import { Component, Input, OnDestroy, OnInit, inject } from "@angular/core";
import
{
    Utilities
} from "@tylertech/shared-module";
import { ICardMetadata } from "@tylertech/tyler-api-types";
import { IAugmentedWithParent, RepositoryFormData } from "../../interfaces";
import { MetadataService, MetadataEventService } from "../../services";
import { CachedRepositoryService } from "@tylertech/core-module";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: "card-metadata",
    templateUrl: "./card.metadata.tmpl.html",
    standalone: false
})
export class CardMetadataComponent implements OnInit
{
    private $metadataService = inject(MetadataService);
    private $metadataEventService = inject(MetadataEventService);
    private $repositoryService = inject(CachedRepositoryService);

    @Input()
    cardMetadata: ICardMetadata;

    @Input()
    viewOnly: boolean;

    @Input()
    model: IAugmentedWithParent;

    @Input()
    datacontroller: RepositoryFormData;

    @Input()
    dense: boolean;

    loading: boolean = false;

    editMode: boolean = false;

    constructor()
    {
        this.$metadataEventService.onLoadCardMetadata.pipe(takeUntilDestroyed()).subscribe(() => this.onMetadataUpdate());
    }

    ngOnInit(): void
    {
        this.onMetadataUpdate();
    }

    private onMetadataUpdate(): void
    {
        if (Utilities.IsNullOrUndefined(this.cardMetadata) || this.loading || !this.model)
            return;
        if (this.viewOnly)
            this.cardMetadata.CanEdit = false;
        const self = this;
        this.loading = true;
        setTimeout(() =>
        {
            if (self.cardMetadata.ViewMetaData)
                self.$metadataService.VerifyLoadChildren(self.cardMetadata.ViewMetaData.Properties, self.cardMetadata.ViewMetaData.TypeName, this.model)
                    .finally(() =>
                    {
                        self.loading = false;
                    });
            else
                self.loading = false;
        }, 50);
    }

    toggleEditMode(): void
    {
        this.editMode = !this.editMode;
        console.log(this);
        console.log(this.editMode);
    }

    onSave(): void
    {
        const self = this;
        self.$repositoryService
            .Save({
                Item1: self.cardMetadata.ViewMetaData.TypeName,
                Item2: Utilities.stringify(self.model),
            })
            .finally(() =>
            {
                self.toggleEditMode();
                self.onMetadataUpdate();
            });
    }
}
